import { Link } from 'react-router-dom'

interface SectorCardProps {
  title: string
  icon: string
  linkTo?: string
}

const SectorCard = ({ title, icon, linkTo }: SectorCardProps) => {
  const inner = (
    <div className="sector-card-content">
      <div className="sector-icon">
        <img src={icon} alt={title} />
      </div>
      <div className="sector-text">
        <h3>{title}</h3>
      </div>
    </div>
  )

  return linkTo ? (
    <Link to={linkTo} className="sector-card clickable">
      {inner}
    </Link>
  ) : (
    <div className="sector-card">
      {inner}
    </div>
  )
}

export default SectorCard
